import React, { useState } from 'react'

// react redux
import { connect } from "react-redux";

// react router
import { Link, NavLink } from 'react-router-dom'

// icons
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";


// styles
import { LeftBarContainer } from '../../../styles/Themes/StylesTheme1/MyAccountLeftBarStyles'

// helpers | common
import {
    globalLogout,
} from "utlis/helpers/Common/CommonHelperFunctions";

function MyAccountLeftBar(props) {
    // props
    const {
        currentUser
    } = props

    // states
    const [openedDropdowns, setOpenedDropdowns] = useState([])

    // show dropdown
    const showDropdown = (ev, id) => {
        ev.preventDefault()
        if (id) {
            const doExist = openedDropdowns.find(item => item === id)
            if (doExist) {
                const updatedList = openedDropdowns.filter(item => item !== id)

                setOpenedDropdowns(updatedList)  // updating to the list
            } else {
                setOpenedDropdowns([...openedDropdowns, id]) // adding id to the list
            }
        }
    }

    const handleLogout = ev => {
        ev.preventDefault()
        const confirm = window.confirm("Are you really want to logout?")

        if (confirm) {
            globalLogout()
        }
    }

    return (
        <LeftBarContainer>
            <div className="left-bar-inner">
                <p className="head st-fw-800 st-fs-17 mb-2">Hi, {currentUser.firstName}</p>

                <div className="links">
                    {/* link */}
                    {/* <div className="link-container">
                        <NavLink to="/account/account-settings" className="d-flex text-decoration-none st-fw-700">
                            <span>Account Settings</span>
                        </NavLink>
                    </div> */}

                    <div className="link-container">
                        <Link to="" className="d-flex text-decoration-none st-fw-700" onClick={(ev) => showDropdown(ev, 'account_settings')}>
                            <span>Account Settings</span>
                            <div className="icon ms-auto">
                                {
                                    openedDropdowns?.length && openedDropdowns.find(item => item === 'account_settings') ? (
                                        <AiOutlineMinus />
                                    ) : (
                                        <AiOutlinePlus />
                                    )
                                }
                            </div>
                        </Link>

                        {
                            /* dropdown menu */
                            openedDropdowns?.length && openedDropdowns.find(item => item === 'account_settings') ? (
                                <div className="dropdown">
                                    <div className="link">
                                        <NavLink to="/account/account-settings/personal-details" className="text-decoration-none">
                                            Personal Details
                                        </NavLink>
                                    </div>
                                    <div className="link">
                                        <NavLink to="/account/account-settings/passwords" className="text-decoration-none">
                                            Password
                                        </NavLink>
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>

                    {/* link */}
                    <div className="link-container">
                        <Link to="/account/orders" className="d-flex text-decoration-none st-fw-700" onClick={(ev) => showDropdown(ev, 'orders')}>
                            <span>Orders</span>
                            <div className="icon ms-auto">
                                {
                                    openedDropdowns?.length && openedDropdowns.find(item => item === 'orders') ? (
                                        <AiOutlineMinus />
                                    ) : (
                                        <AiOutlinePlus />
                                    )
                                }
                            </div>
                        </Link>

                        {
                            /* dropdown menu */
                            openedDropdowns?.length && openedDropdowns.find(item => item === 'orders') ? (
                                <div className="dropdown">
                                    <div className="link">
                                        <NavLink to="/account/orders/all-orders" className="text-decoration-none">
                                            All Orders
                                        </NavLink>
                                    </div>
                                    {/* <div className="link">
                                        <NavLink to="/account/orders/pending-orders" className="text-decoration-none">
                                            Pending Orders
                                        </NavLink>
                                    </div>
                                    <div className="link">
                                        <NavLink to="/account/orders/completed-orders" className="text-decoration-none">
                                            Completed Orders
                                        </NavLink>
                                    </div> */}
                                </div>
                            ) : null
                        }
                    </div>

                    {/* link */}
                    <div className="link-container d-none">
                        <Link to="/" className="d-flex text-decoration-none st-fw-700" onClick={(ev) => showDropdown(ev, 'addresses')}>
                            <span>Addresses</span>
                            <div className="icon ms-auto">
                                {
                                    openedDropdowns?.length && openedDropdowns.find(item => item === 'addresses') ? (
                                        <AiOutlineMinus />
                                    ) : (
                                        <AiOutlinePlus />
                                    )
                                }
                            </div>
                        </Link>

                        {
                            /* dropdown menu */
                            openedDropdowns?.length && openedDropdowns.find(item => item === 'addresses') ? (
                                <div className="dropdown">
                                    <div className="link">
                                        <NavLink to="/account/address/shipping-address" className="text-decoration-none">
                                            Shipping Addresses
                                        </NavLink>

                                    </div>
                                    <div className="link">
                                        <NavLink to="/account/address/billing-address" className="text-decoration-none">
                                            Billing Addresses
                                        </NavLink>
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>

                    {/* link */}
                    {/* <div className="link-container">
                        <NavLink to="/account/credit-card" className="d-flex text-decoration-none st-fw-700">
                            <span>Mnage Credit Cards</span>
                        </NavLink>
                    </div> */}

                    {/* link */}
                    {/* <div className="link-container">
                        <NavLink to="/account/favriots" className="d-flex text-decoration-none st-fw-700">
                            <span>My Favorites</span>
                        </NavLink>
                    </div> */}

                    {/* link */}
                    <div className="link-container">
                        <NavLink to="/account/favriots" className="d-flex text-decoration-none st-fw-700" onClick={handleLogout}>
                            <span>Log Out</span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </LeftBarContainer>
    )
}


const getDataFromStore = (state) => {
    return {
        currentUser: state.auth.currentUser,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: param => dispatch(func(param)),
//     };
// };

export default connect(getDataFromStore, null)(MyAccountLeftBar);